@if (isLoadingState) {
  <wpro-spinner-default></wpro-spinner-default>
}
@if (!isLoadingState) {
  <div class="fdx-o-grid__row fdx-o-grid__row--center">
    <div class="fdx-u-align--center">
      <h1 class="fdx-c-header fdx-c-header--h2 fdx-u-mb--3" id="title">
        {{ 'verificationMethod.verifyYourIdentityHeader' | translate}}
      </h1>
    </div>
    @if (_channels.length>1) {
      <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--8 fdx-u-mt--1@small fdx-u-align--center">
        <h1 class="fdx-c-header fdx-c-header--h4" id="verifyMethodTitle">
          {{ 'verificationMethod.verifyMethodTitle' | translate }}
        </h1>
      </div>
    }
    <div class="fdx-u-my--4 fdx-u-align--center"
      aria-atomic="true" aria-live="assertive">
      <h2 class="fdx-c-paragraph fdx-u-mb--0" id="verifyMethodSubtitle">
        {{ 'verificationMethod.verifyMethodSubtitle' | translate }}
      </h2>
    </div>
  </div>
  @for (channel of _channels; track channel) {
    <div class="fdx-c-tabs-radio fdx-c-tabs-radio--tile fdx-u-my--3">
      <input type="radio"
        name="method"
        [id]="channel.deliveryMethod"
        [value]="channel.deliveryMethod"
        class="fdx-c-select-tile__input fdx-c-tabs-radio__radio"
        aria-describedby="radio-label"
        (change)="methodSelected(channel.deliveryMethod)">
        <label class="fdx-c-select-tile__label fdx-c-tabs-radio__label fdx-u-p--4 fdx-u-width--100 fdx-u-text-transform-min-height--none" [for]="channel.deliveryMethod">
          <wpro-method-list-item [channel]="channel"></wpro-method-list-item>
        </label>
      </div>
    }
    <div class="fdx-o-grid__row fdx-o-grid__row--center">
      <!-- Confirm button -->
      <div class="fdx-o-grid__item fdx-o-grid__item--12 fdx-u-align--center fdx-u-mb--3 fdx-u-mt--7">
        <button id="confirm-btn" (click)="sendPin()"
          class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive"
          aria-atomic="true" aria-live="assertive" [disabled]="_method === ''">
          {{ 'common.continue' | translate }}
        </button>
      </div>
      <!-- Cancel button -->
      <div class="fdx-o-grid__item fdx-u-align--center">
        <button #cancelBtnRef id="cancelBtn" (click)="apiError.next(false); apiError.complete()"
          class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive fdx-u-cursor--pointer fdx-u-align--center"
          aria-atomic="true" aria-live="assertive">
          {{'common.cancel' | translate}}
        </button>
      </div>
    </div>
  }
